export const SET_LOADING_DATA = '@client/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@client/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@client/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@client/GET_ALL_SUCCESS';

export const GET_FILTER_REQUEST = '@client/GET_FILTER_REQUEST';
export const GET_FILTER_SUCCESS = '@client/GET_FILTER_SUCCESS';

export const GET_BY_ID_REQUEST = '@client/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@client/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@client/SAVE_REQUEST';
export const SAVE_SUCCESS = '@client/SAVE_SUCCESS';

export const SAVE_IMAGES = '@client/SAVE_IMAGES';
export const DELETE_IMAGE = '@client/DELETE_IMAGE';

export const DELETE_ITEM = '@client/DELETE_ITEM';
export const EDIT_ITEM = '@client/EDIT_ITEM';

export const SEARCH = '@client/SEARCH';

export const SAVE_RATING_REQUEST = '@client/SAVE_RATING_REQUEST';

export const SAVE_CHECKLIST_REQUEST = '@client/SAVE_CHECKLIST_REQUEST';

export const SET_PAGE = '@client/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@client/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@client/SET_ORDER';
export const SET_ORDERBY = '@client/SET_ORDEBY';
